import org.jetbrains.compose.web.css.Color

object Colors {
    val primary = Color("#25AAFF")

    val dark = Color("#999999")
}